<!-- <template>
  <div>
    <div class="row justify-content-end mb-3">
      <div class="col-auto">
        <button @click="refresh" class="btn btn-secondary">
          <i class="fa fa-sync"></i> Actualiser
        </button>
      </div>
    </div>

    <h5>Historique des commandes</h5>
    <vue-data-table :headers="headers" :data="orderHistories" :items-per-page="10" :buttons="buttons" />

    <hr class="my-5" />

    <h5>Historique des ventes</h5>
    <vue-data-table :headers="headers" :data="saleHistories" :items-per-page="10"  />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default { 
  computed: {
    ...mapGetters("history", {
      orderHistories: "getOrderHistories",
      saleHistories: "getSaleHistories",
    }),
  },
  mounted() {
    this.refresh();
  },
  data() {
    return {
      headers: [
        { field: "reference", label: "Référence", class: "" },
        { field: "customerFullName", label: "Client", class: "" },
        { field: "customerCity", label: "Ville", class: "" },
        { field: "passPermit", label: "LP", class: "" },
        { field: "userFullName", label: "Creer par", class: "" },
        { field: "updatedByFullName", label: "Modifier par", class: "" },
        { field: "validated", label: "Statut", class: "" },
        { field: "remark", label: "Remarque", class: "" },
        { field: "changed_at", label: "Modifié le", class: "" },
        { field: "totalPriceTTC", label: "Ancien Total TTC", class: "" },
        { field: "newTotalPriceTTC", label: "Nouveau Total TTC", class: "" },
        { field: "totalQuantity", label: "Ancienne Quantité", class: "" },
        { field: "newTotalQuantity", label: "Nouvelle Quantité", class: "" },
      ],
      buttons: [
        {
          label: 'Détails',
          icon: 'bi bi-info-square',
          class: 'btn btn-primary',
          action: (order) => {
            this.$router.push({
              name: 'updates-details',
              params: { reference: order.reference },
            });
          },
        },
      ],
    };
  }, 
  methods: {
    async refresh() {
      await this.$store.dispatch("history/fetchOrderHistories");
      await this.$store.dispatch("history/fetchSaleHistories");
    },
  },
};
</script> -->
<template>
  <div>
    <div class="row justify-content-end mb-3">
      <div class="col-auto">
        <button @click="refresh" class="btn btn-secondary">
          <i class="fa fa-sync"></i> Actualiser
        </button>
      </div>
    </div>


    <div>
      Historique des Commandes
    </div>
    <vue-data-table :headers="orderHeaders" :data="orderHistories" :items-per-page="10" :buttons="orderButtons">
      <!-- Price Comparison -->
      <template #cell-totalPriceTTC="{ row }">
        <div class="text-start">
          <span
            :class="{ 'text-decoration-line-through text-danger': row.newTotalPriceTTC && row.newTotalPriceTTC != row.totalPriceTTC }">
            {{ formatCurrency(row.totalPriceTTC) }}
          </span>
          <span v-if="row.newTotalPriceTTC && row.newTotalPriceTTC != row.totalPriceTTC" class="text-success ms-2">
            → {{ formatCurrency(row.newTotalPriceTTC) }}
            <span v-if="(row.newTotalPriceTTC - row.totalPriceTTC) > 0" class="text-danger">
              (+{{ formatCurrency(row.newTotalPriceTTC - row.totalPriceTTC) }})
            </span>
            <span v-else class="text-success">
              ({{ formatCurrency(row.newTotalPriceTTC - row.totalPriceTTC) }})
            </span>
          </span>
          <span v-if="!row.newTotalPriceTTC || row.newTotalPriceTTC == row.totalPriceTTC">
            {{ formatCurrency(row.totalPriceTTC) }}
          </span>
        </div>
      </template>

      <!-- Quantity Comparison -->
      <template #cell-totalQuantity="{ row }">
        <div class="text-start">
          <span
            :class="{ 'text-decoration-line-through text-danger': row.newTotalQuantity && row.newTotalQuantity != row.totalQuantity }">
            {{ row.totalQuantity }}
          </span>
          <span v-if="row.newTotalQuantity && row.newTotalQuantity != row.totalQuantity" class="text-success ms-2">
            → {{ row.newTotalQuantity }}
            <span v-if="(row.newTotalQuantity - row.totalQuantity) > 0" class="text-danger">
              (+{{ (row.newTotalQuantity - row.totalQuantity) }})
            </span>
            <span v-else class="text-success">
              ({{ (row.newTotalQuantity - row.totalQuantity) }})
            </span>
          </span>
          <span v-if="!row.newTotalQuantity || row.newTotalQuantity == row.totalQuantity">
            {{ row.totalQuantity }}
          </span>
        </div>
      </template>

      <!-- Status Badge -->
      <template #cell-validated="{ row }">
        <span :class="{
          'badge bg-success': row.validated === 'Validé',
          'badge bg-danger': row.validated === 'Non Validé'
        }">
          {{ row.validated }}
        </span>
      </template>

      <!-- Date Formatting -->
      <template #cell-changed_at="{ row }">
        {{ formatDate(row.changed_at) }}
      </template>
    </vue-data-table>

    <br>
    <div>
      Historique des Ventes
    </div>
    <vue-data-table :headers="saleHeaders" :data="saleHistories" :items-per-page="10" :buttons="saleButtons">
      <!-- Price Comparison -->
      <template #cell-totalPriceTTC="{ row }">
        <div class="text-start ">
          <span
            :class="{ 'text-decoration-line-through text-danger': row.newTotalPriceTTC && row.newTotalPriceTTC != row.totalPriceTTC }">
            {{ formatCurrency(row.totalPriceTTC) }}
          </span>
          <span v-if="row.newTotalPriceTTC && row.newTotalPriceTTC != row.totalPriceTTC" class="text-success ms-2">
            → {{ formatCurrency(row.newTotalPriceTTC) }}
            <span v-if="(row.newTotalPriceTTC - row.totalPriceTTC) > 0" class="text-danger">
              (+{{ formatCurrency(row.newTotalPriceTTC - row.totalPriceTTC) }})
            </span>
            <span v-else class="text-success">
              ({{ formatCurrency(row.newTotalPriceTTC - row.totalPriceTTC) }})
            </span>
          </span>
          <span v-if="!row.newTotalPriceTTC || row.newTotalPriceTTC == row.totalPriceTTC">
            {{ formatCurrency(row.totalPriceTTC) }}
          </span>
        </div>
      </template>

      <!-- Quantity Comparison -->
      <template #cell-totalQuantity="{ row }">
        <div class="text-start">
          <span
            :class="{ 'text-decoration-line-through text-danger': row.newTotalQuantity && row.newTotalQuantity != row.totalQuantity }">
            {{ row.totalQuantity }}
          </span>
          <span v-if="row.newTotalQuantity && row.newTotalQuantity != row.totalQuantity" class="text-success ms-2">
            → {{ row.newTotalQuantity }}
            <span v-if="(row.newTotalQuantity - row.totalQuantity) > 0" class="text-danger">
              (+{{ (row.newTotalQuantity - row.totalQuantity) }})
            </span>
            <span v-else class="text-success">
              ({{ (row.newTotalQuantity - row.totalQuantity) }})
            </span>
          </span>
          <span v-if="!row.newTotalQuantity || row.newTotalQuantity == row.totalQuantity">
            {{ row.totalQuantity }}
          </span>
        </div>
      </template>

      <!-- Status Badge -->
      <template #cell-validated="{ row }">
        <span :class="{
          'badge bg-success': row.validated === 'Validé',
          'badge bg-danger': row.validated === 'Non Validé'
        }">
          {{ row.validated }}
        </span>
      </template>

      <!-- Container Number -->
      <template #cell-containerNumber="{ row }">
        <span v-if="row.containerNumber" class="badge bg-info">
          {{ row.containerNumber }}
        </span>
        <span v-else class="text-muted">N/A</span>
      </template>

      <template #cell-changed_at="{ row }">
        {{ formatDate(row.changed_at) }}
      </template>

    </vue-data-table>


  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("history", {
      orderHistories: "getOrderHistories",
      saleHistories: "getSaleHistories"
    }),
  },
  mounted() {
    this.refresh();
  },
  data() {
    return {
      // Order History Table Config
      orderHeaders: [
        { field: "reference", label: "Référence", class: "text-center" },
        { field: "customerFullName", label: "Client", class: "text-left" },
        { field: "customerCity", label: "Ville", class: "text-left" },
        { field: "passPermit", label: "LP", class: "text-center" },
        { field: "userFullName", label: "Créé par", class: "text-left" },
        { field: "updatedByFullName", label: "Modifié par", class: "text-left" },
        { field: "validated", label: "Statut", class: "text-center" },
        { field: "remark", label: "Remarque", class: "text-left" },
        { field: "changed_at", label: "Modifié le", class: "text-center" },
        { field: "totalPriceTTC", label: "Total TTC", class: "text-end fw-bold" },
        { field: "totalQuantity", label: "Quantité", class: "text-center fw-bold" },
      ],
      orderButtons: [
        {
          label: 'Détails',
          icon: 'bi bi-info-circle',
          class: 'btn btn-sm btn-primary',
          action: (order) => {
            this.$router.push({
              name: 'orders-updates-details',
              params: { reference: order.reference },
            });
          },
        },
      ],

      // Sale History Table Config
      saleHeaders: [
        { field: 'reference', label: 'BL', class: '' },
        { field: 'invoiceReference', label: 'Facture', class: '' },
        { field: 'customerFullName', label: 'Client', class: '' },
        { field: "changed_at", label: "Modifié le", class: "text-center" },
        { field: 'totalPriceTTC', label: 'Total TTC', class: 'text-primary' },
        { field: 'totalQuantity', label: 'Quantité Totale', class: '' },
        { field: 'amountPaid', label: 'Montant payé', class: 'text-success' },
        { field: 'amountUnpaid', label: 'Montant impayé', class: 'text-danger' },
        { field: 'passPermit', label: 'LP', class: '' },
        { field: 'validated', label: 'État', class: 'text-danger' },
        { field: 'remark', label: 'NB', class: 'text-danger' },
        { field: "userFullName", label: "Créé par", class: "text-left" },
        { field: "updatedByFullName", label: "Modifié par", class: "text-left" },
      ],
      saleButtons: [
        {
          label: 'Détails',
          icon: 'bi bi-info-circle',
          class: 'btn btn-sm btn-primary',
          action: (sale) => {
            this.$router.push({
              name: 'sales-updates-details',
              params: { reference: sale.reference },
            });
          },
        },
      ],
    };
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("history/fetchOrderHistories");
      await this.$store.dispatch("history/fetchSaleHistories");
    },
    formatCurrency(value) {
      if (isNaN(value) || value === null || value === undefined) return 'N/A';
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'MAD'
      }).format(value);
    },
    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleString('fr-FR');
    },
  },
};
</script>

<style scoped>
.text-decoration-line-through {
  text-decoration: line-through;
}

.badge {
  font-size: 0.85em;
  padding: 0.35em 0.65em;
  font-weight: 500;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  margin-bottom: -1px;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .nav-link:not(.active):hover {
  border-color: #e9ecef #e9ecef #dee2e6;
}
</style>